__turbopack_context__.v({
  "ContentNewsletter": "_9SlYoG_ContentNewsletter",
  "author": "_9SlYoG_author",
  "banner-container": "_9SlYoG_banner-container",
  "buttonBox": "_9SlYoG_buttonBox",
  "cAuthorName": "_9SlYoG_cAuthorName",
  "cardSection": "_9SlYoG_cardSection",
  "category": "_9SlYoG_category",
  "category-name": "_9SlYoG_category-name",
  "categoryAuthor": "_9SlYoG_categoryAuthor",
  "categoryOther": "_9SlYoG_categoryOther",
  "categorySection": "_9SlYoG_categorySection",
  "cnewsletterContainer": "_9SlYoG_cnewsletterContainer",
  "content": "_9SlYoG_content",
  "description": "_9SlYoG_description",
  "formGroup": "_9SlYoG_formGroup",
  "image": "_9SlYoG_image",
  "inputBox": "_9SlYoG_inputBox",
  "newLetterContainer": "_9SlYoG_newLetterContainer",
  "newsLFooter": "_9SlYoG_newsLFooter",
  "newsletter-copy": "_9SlYoG_newsletter-copy",
  "newsletterSection": "_9SlYoG_newsletterSection",
  "part-4": "_9SlYoG_part-4",
  "part-6": "_9SlYoG_part-6",
  "part-8": "_9SlYoG_part-8",
  "pipeClass": "_9SlYoG_pipeClass",
  "postCardContainer": "_9SlYoG_postCardContainer",
  "tagLink": "_9SlYoG_tagLink",
  "textBox": "_9SlYoG_textBox",
  "titleSection": "_9SlYoG_titleSection",
  "topPaddingWithCookie": "_9SlYoG_topPaddingWithCookie",
  "topPaddingWithoutCookie": "_9SlYoG_topPaddingWithoutCookie",
  "v-card": "_9SlYoG_v-card",
});
